import React, { useContext, useState } from "react";
import { Button, Fab } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";

import { Storage } from "aws-amplify";
import aws_exports from "../aws-exports";
import { API, graphqlOperation } from "aws-amplify";
import { createTaxDocument } from "../graphql/mutations";
import ColoredLinearProgress from "./LinearProgress";

/*
import ContactForm from "../components/contact-form";
import ContactTable from "../components/contact-table";
*/

import { UserContext } from "../App";

export default function TaxDocumentNew() {
  const [loading, setLoading] = useState(false);

  const { user, setUser, signOutState, setSignOutState, taxReturn, setTaxReturn } = useContext(UserContext);

  const handleChange = async (e) => {
    const file = e.target.files[0];
    setLoading(true);
    //console.log(e.target.file[0]);
    try {
      const key = await Storage.put(user.attributes.sub + "-current-" + file.name, file, {
        contentType: file.type,
        level: "public",
      });
      console.log("Tax return in TaxDocumentNew:", taxReturn);
      const input = {
        fileName: file.name,
        s3key: key.key,
        s3bucket: aws_exports.aws_user_files_s3_bucket,
        s3region: aws_exports.aws_project_region,
        verified: false,
        taxReturnID: taxReturn.id,
      };

      const newDocument = API.graphql(graphqlOperation(createTaxDocument, { input: input }));
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
    setLoading(false);
  };
  /*  
<Button
          color="secondary"
          variant="contained"
          component="span"
          position="top-right"
        >
         <Fab
          color="secondary"
          aria-label="add"
          variant="contained"
          component="span"
          position="top-right"
        >
          <AddIcon />
        </Fab>
*/
  return (
    <>
      {loading && <ColoredLinearProgress />}
      <label htmlFor="upload-attachment">
        <input style={{ display: "none" }} id="upload-attachment" name="upload-attachment" type="file" onChange={(evt) => handleChange(evt)} />
        <Button color="secondary" variant="contained" component="span" position="top-right" disabled={loading}>
          Upload Document
        </Button>
      </label>
    </>
  );

  //return "TaxDocumentNew";
}
